import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Row,
} from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import moment from "moment";
import { parse } from "date-fns";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import NotificationService from "../../services/notification.service";
import { useSnackbar } from "notistack";

export const FootballNotificationEdit = () => {
  const [loader, setLoader] = useState(false);
  const [removeDate, setRemoveDate] = useState(false);
  const [error, setError] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedImageApi, setSelectedImageApi] = useState([]);
  const [update, setUpdate] = useState(false);
  const [newImage, setNewImage] = useState([]);
  const [newData, setNewData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");
  const countryDropdownRef = useRef(null);
  const countrySearchTimeout = useRef(null);

  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const language = [
    { name: "English", sname: "en" },
    { name: "Amharic", sname: "am" },
    { name: "Arabic", sname: "ar" },
    { name: "French", sname: "fr" },
    { name: "German", sname: "de" },
    { name: "Italian", sname: "it" },
    { name: "Spanish", sname: "es" },
    { name: "Swahili", sname: "sw" },
    { name: "Zulu", sname: "zu" },
  ];

  const handleOpen = async () => {
    if (id !== "add") {
      setUpdate(true);

      const response = await NotificationService.getSingleNotification(
        id,
        "football"
      );
      const result = JSON.parse(response.data.payload);
      setNewData(result);
      Object.keys(result).forEach((lang, index) => {
        formik.setFieldValue("id", response.data.id);
        formik.setFieldValue(`languages[${index}].title`, result[lang].title);
        formik.setFieldValue(
          `languages[${index}].description`,
          result[lang].description
        );
        formik.setFieldValue(
          `languages[${index}].buttonText`,
          result[lang].buttonText
        );
        formik.setFieldValue(`languages[${index}].image`, result[lang].image);
        formik.setFieldValue("timestamp", Number(response.data.timestamp));
      });
      formik.setFieldValue("isfromfb", response.data.isfromfb);
      if (response.data.country) {
        formik.setFieldValue("country", response.data.country);
      }
      if (response.data.sound) {
        formik.setFieldValue("sound", response.data.sound);
      }
    }
  };

  useEffect(() => {
    handleOpen();
  }, [id]);

  // Fetch countries with debounced search
  useEffect(() => {
    clearTimeout(countrySearchTimeout.current);
    countrySearchTimeout.current = setTimeout(async () => {
      try {
        const response = await NotificationService.getCountries(countrySearch);
        if (response && response.data) {
          setCountries(response.data);
        }
      } catch (err) {
        console.error("Error fetching countries:", err);
      }
    }, 300);
    return () => clearTimeout(countrySearchTimeout.current);
  }, [countrySearch]);

  // Close country dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setCountryDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const initialValue = {
    languages: language.map((item) => ({
      title: "",
      description: "",
      buttonText: "",
      language: item.sname,
      image: "",
    })),
    timestamp: "",
    apptype: "",
    isfromfb: true,
    devicetoken: "",
    country: "",
    sound: ""
  };

  const sendNotification = async (values) => {
    const { timestamp, languages, isfromfb, devicetoken, country, sound } = values;
    const filteredLanguages = languages.filter(
      (lang) => lang.title !== "" && lang.description !== ""
    );
    let error = [];
    setIsSubmitting(true);

    const validateError = () => {
      const data = formik.values.languages;
      const updatedData = data.map((item, index) => {
        let titleError = "";
        let descriptionError = "";
        let buttonError = "";

        if (
          index === 0 &&
          item.title === "" &&
          item.description === "" &&
          item.buttonText === ""
        ) {
          titleError = "Title cannot be empty";
          descriptionError = "Description cannot be empty";
          buttonError = "Button Text cannot be empty";
        } else if (item.title === "" && item.description !== "") {
          titleError = "Title cannot be empty";
        } else if (item.title !== "" && item.description === "") {
          descriptionError = "Description cannot be empty";
        } else if (
          item.title !== "" &&
          item.description !== "" &&
          item.buttonText === ""
        ) {
          buttonError = "Button Text cannot be empty";
        }

        return {
          ...item,
          isError:
            (index === 0 &&
              item.title === "" &&
              item.description === "" &&
              item.buttonText === "") ||
            (item.title === "" && item.description !== "") ||
            (item.title !== "" && item.description === "") ||
            (item.title !== "" &&
              item.description !== "" &&
              item.buttonText === ""),
          titleError,
          descriptionError,
          buttonError,
        };
      });
      error = updatedData;
      setError(updatedData);
    };

    validateError();

    const filteredOptions = filteredLanguages.map((option) => {
      const { image, ...filteredOption } = option;
      return filteredOption;
    });

    let isError = false;

    for (let item of error) {
      if (item.isError === true) {
        isError = true;
        break;
      }
    }
    if (!isError) {
      if (!values.id) {
        try {
          setLoader(true);
          const formData = new FormData();
          formData.append("payload", JSON.stringify(filteredOptions));
          formData.append("isfromfb", isfromfb);
          if (selectedImage["0"] !== undefined) {
            formData.append(`en_image`, selectedImageApi["0"]);
          }
          if (selectedImage["1"] !== undefined) {
            formData.append(`am_image`, selectedImageApi["1"]);
          }
          if (selectedImage["2"] !== undefined) {
            formData.append(`ar_image`, selectedImageApi["2"]);
          }
          if (selectedImage["3"] !== undefined) {
            formData.append(`fr_image`, selectedImageApi["3"]);
          }
          if (selectedImage["4"] !== undefined) {
            formData.append(`de_image`, selectedImageApi["4"]);
          }
          if (selectedImage["5"] !== undefined) {
            formData.append(`it_image`, selectedImageApi["5"]);
          }
          if (selectedImage["6"] !== undefined) {
            formData.append(`es_image`, selectedImageApi["6"]);
          }
          if (selectedImage["7"] !== undefined) {
            formData.append(`sw_image`, selectedImageApi["7"]);
          }
          if (selectedImage["8"] !== undefined) {
            formData.append(`zu_image`, selectedImageApi["8"]);
          }
          if (timestamp !== null && timestamp !== "") {
            formData.append("timestamp", timestamp);
          }
          if (devicetoken !== null && devicetoken !== "") {
            formData.append("devicetoken", devicetoken);
          }
          if (country !== null && country !== "") {
            formData.append("country", country);
          }
          if (sound !== null && sound !== "") {
            formData.append("sound", sound);
          }
          await NotificationService.Notification(formData, "football");
          enqueueSnackbar("Notification sent SuccessFully", {
            variant: "success",
          });
          setLoader(false);
          navigate(-1);
        } catch (error) {
          console.error("Error sending notification:", error.message);
        }
      } else {
        try {
          setLoader(true);
          const formData = new FormData();
          formData.append("payload", JSON.stringify(filteredOptions));
          formData.append("isfromfb", isfromfb);
          if (selectedImage["0"] !== undefined) {
            formData.append(`en_image`, selectedImageApi["0"]);
          }
          if (selectedImage["1"] !== undefined) {
            formData.append(`am_image`, selectedImageApi["1"]);
          }
          if (selectedImage["2"] !== undefined) {
            formData.append(`ar_image`, selectedImageApi["2"]);
          }
          if (selectedImage["3"] !== undefined) {
            formData.append(`fr_image`, selectedImageApi["3"]);
          }
          if (selectedImage["4"] !== undefined) {
            formData.append(`de_image`, selectedImageApi["4"]);
          }
          if (selectedImage["5"] !== undefined) {
            formData.append(`it_image`, selectedImageApi["5"]);
          }
          if (selectedImage["6"] !== undefined) {
            formData.append(`es_image`, selectedImageApi["6"]);
          }
          if (selectedImage["7"] !== undefined) {
            formData.append(`sw_image`, selectedImageApi["7"]);
          }
          if (selectedImage["8"] !== undefined) {
            formData.append(`zu_image`, selectedImageApi["8"]);
          }
          if (timestamp !== null && timestamp !== "") {
            formData.append("timestamp", timestamp);
          }
          if (devicetoken !== null && devicetoken !== "") {
            formData.append("devicetoken", devicetoken);
          }
          if (country !== null && country !== "") {
            formData.append("country", country);
          }
          if (sound !== null && sound !== "") {
            formData.append("sound", sound);
          }
          await NotificationService.NotificationUpdate(
            values.id,
            formData,
            "football"
          );
          enqueueSnackbar("Notification update SuccessFully", {
            variant: "success",
          });
          setLoader(false);
          navigate(-1);
        } catch (error) {
          console.error("Error sending notification:", error.message);
        }
      }
    } else {
      handleError();
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    onSubmit: sendNotification,
  });

  const handleError = () => {
    const data = formik.values.languages;
    const updatedData = data.map((item, index) => {
      let titleError = "";
      let descriptionError = "";
      let buttonError = "";

      if (
        index === 0 &&
        item.title === "" &&
        item.description === "" &&
        item.buttonText === ""
      ) {
        titleError = "Title cannot be empty";
        descriptionError = "Description cannot be empty";
        buttonError = "Button Text cannot be empty";
      } else if (item.title === "" && item.description !== "") {
        titleError = "Title cannot be empty";
      } else if (item.title !== "" && item.description === "") {
        descriptionError = "Description cannot be empty";
      } else if (
        item.title !== "" &&
        item.description !== "" &&
        item.buttonText === ""
      ) {
        buttonError = "Button Text cannot be empty";
      }

      return {
        ...item,
        isError:
          (index === 0 &&
            item.title === "" &&
            item.description === "" &&
            item.buttonText === "") ||
          (item.title === "" && item.description !== "") ||
          (item.title !== "" && item.description === "") ||
          (item.title !== "" &&
            item.description !== "" &&
            item.buttonText === ""),
        titleError,
        descriptionError,
        buttonError,
      };
    });
    setError(updatedData);
  };

  useEffect(() => {
    if (isSubmitting) {
      handleError();
    }
  }, [formik.values]);

  const deleteHandler = (id, index) => {
    setSelectedImage((prevImages) => {
      const updatedImagesApi = [...prevImages];
      updatedImagesApi[index] = "";
      return updatedImagesApi;
    });
    setSelectedImageApi((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = "";
      return updatedImages;
    });
    formik.setFieldValue(`languages[${index}].image`, "");
    const fileInput = document.getElementById(`fileInput-${index}`);
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleChange = (e, index) => {
    const selectedFile = e.currentTarget.files[0];
    setNewImage((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = true;
      return updatedImages;
    });
    const imageUrl = URL.createObjectURL(selectedFile);
    setSelectedImage((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = imageUrl;
      return updatedImages;
    });
    setSelectedImageApi((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages[index] = selectedFile;
      return updatedImages;
    });
    formik.setFieldValue(`languages[${index}].image`, selectedFile);
  };

  const formatDate = (date) => {
    return `${date}`;
  };

  const handleDateChnage = (date) => {
    setRemoveDate(true);
    const newDate = formatDate(date);
    const dateShow = new Date();
    dateShow.setMilliseconds(0);
    dateShow.setSeconds(0);
    const newDateInMilliseconds = parse(
      newDate,
      "dd-MM-yyyy HH:mm",
      new Date()
    ).getTime();
    formik.setFieldValue(
      "timestamp",
      newDateInMilliseconds === dateShow.getTime()
        ? null
        : newDateInMilliseconds
    );
  };

  const handleClearDate = () => {
    setRemoveDate(false);
    formik.setFieldValue("timestamp", null);
  };

  const handleAODChange = (e) => {
    const checked = e.target.checked;
    formik.setFieldValue("isfromfb", Boolean(checked));
  };

  return (
    <>
      <div className="page-header2"></div>
      <div
        className="me-auto d-flex justify-content-start"
        style={{ fontWeight: 600, fontSize: "20px", marginBottom: "10px" }}
      >
        SEND NOTIFICATION
      </div>
      <Row>
        <Card className="custom-card">
          <form onSubmit={formik.handleSubmit}>
            <Card.Body>
              <Accordion defaultActiveKey={0}>
                {language.map((item, index) => (
                  <Accordion.Item
                    eventKey={index}
                    key={index}
                    className="accodian-items"
                    style={{
                      border: error[index]?.isError
                        ? "1px solid red"
                        : "1px solid #EAEDF7",
                    }}
                  >
                    <Accordion.Header className="accodian-headers">
                      {item.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      <FormGroup className="form-group">
                        <Row className=" row-sm">
                          <Col md={2} className="d-flex align-items-start mt-2">
                            <Form.Label className="text-dark mt-0">
                              {"Title"}
                            </Form.Label>
                          </Col>
                          <Col
                            md={10}
                            className="d-flex flex-column align-items-start"
                          >
                            <Form.Control
                              placeholder="Title"
                              name={`languages[${index}].title`}
                              onChange={formik.handleChange}
                              value={formik.values.languages[index].title}
                            />
                            <p className="text-start error">
                              {error[index]?.isError === true
                                ? error[index]?.titleError !== "" &&
                                error[index]?.titleError
                                : ""}
                            </p>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup className="form-group">
                        <Row className=" row-sm">
                          <Col md={2} className="d-flex align-items-start mt-2">
                            <Form.Label className="text-dark mt-0">
                              {"Message"}
                            </Form.Label>
                          </Col>
                          <Col
                            md={10}
                            className="d-flex flex-column align-items-start"
                          >
                            <Form.Control
                              placeholder="Message"
                              name={`languages[${index}].description`}
                              onChange={formik.handleChange}
                              value={formik.values.languages[index].description}
                            />
                            <p className="text-start error">
                              {error[index]?.isError === true
                                ? error[index]?.descriptionError !== "" &&
                                error[index]?.descriptionError
                                : ""}
                            </p>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup className="form-group">
                        <Row className=" row-sm">
                          <Col md={2} className="d-flex align-items-start mt-2">
                            <Form.Label className="text-dark mt-0">
                              {"Button Text"}
                            </Form.Label>
                          </Col>
                          <Col
                            md={10}
                            className="d-flex flex-column align-items-start"
                          >
                            <Form.Control
                              placeholder="Button Text"
                              type="text"
                              name={`languages[${index}].buttonText`}
                              onChange={formik.handleChange}
                              value={formik.values.languages[index].buttonText}
                            />
                            <p className="text-start error">
                              {error[index]?.isError === true
                                ? error[index]?.buttonError !== "" &&
                                error[index]?.buttonError
                                : ""}
                            </p>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup className="form-group">
                        <Row className=" row-sm">
                          <Col md={2} className="d-flex align-items-start mt-2">
                            <Form.Label className="text-dark mt-0">
                              {"File"}
                            </Form.Label>
                          </Col>
                          <Col
                            md={6}
                            className="d-flex flex-column align-items-start"
                          >
                            <Form.Control
                              type="file"
                              id={`fileInput-${index}`}
                              onChange={(e) => handleChange(e, index)}
                            />
                            <p className="text-start error">
                              {error[index]?.isError === true
                                ? error[index]?.imageError !== "" &&
                                error[index]?.imageError
                                : ""}
                            </p>
                            {update ? (
                              // <div className="pos-relative">
                              <img
                                key={index}
                                src={
                                  newImage[index]
                                    ? selectedImage[index]
                                    : formik.values.languages[index].image
                                }
                                style={{
                                  marginTop: "10px",
                                  height:
                                    newImage[index] ||
                                      formik.values.languages[index].image
                                      ? "300px"
                                      : "0px",
                                }}
                                alt=""
                              />
                            ) : (
                              <div className="pos-relative">
                                <img
                                  src={selectedImage[index]}
                                  style={{
                                    marginTop: "10px",
                                    height: selectedImage[index]
                                      ? "300px"
                                      : "0px",
                                    width: "450px",
                                  }}
                                  alt=""
                                />
                                {selectedImage[index] && (
                                  <button
                                    onClick={() =>
                                      deleteHandler(selectedImage[index], index)
                                    }
                                    style={{
                                      right: "0px",
                                      top: "10px",
                                      position: "absolute",
                                    }}
                                    className="btn btn-primary"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </FormGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Card.Body>
            <Card.Footer>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "12px",
                  gap: 50,
                  flexWrap: "wrap"
                }}
              >
                <div className="d-flex align-items-center">
                  <Form.Label
                    style={{
                      textAlign: "start",
                      color: "#000",
                      fontWeight: "500",
                      marginRight: "10px",
                    }}
                  >
                    Notification Schedule
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // maxWidth: "140px",
                      // minWidth: "140px",
                    }}
                  >
                    <DatePicker
                      style={{
                        padding: "18px",
                        border: "1px solid #e8e8f7",
                        textAlign: "start",
                        maxWidth: "190px",
                        minWidth: "190px",
                        paddingLeft: "10px",
                      }}
                      value={moment(formik.values.timestamp).format(
                        "DD-MM-YYYY HH:mm"
                      )}
                      onChange={(date) => handleDateChnage(date)}
                      format="DD-MM-YYYY HH:mm"
                      placeholder="Notification schedule time"
                      name="timestamp"
                      minDate={new Date()}
                      plugins={[
                        <TimePicker
                          format="HH:mm"
                          hideSeconds
                          position="top"
                        />,
                      ]}
                    />
                    {removeDate && (
                      <span
                        onClick={handleClearDate}
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                      >
                        <i className="fas fa-close"></i>
                      </span>
                    )}
                  </div>
                </div>



                <div className="d-flex align-items-center" ref={countryDropdownRef} style={{ position: "relative" }}>
                  <Form.Label
                    style={{
                      textAlign: "start",
                      color: "#000",
                      fontWeight: "500",
                      marginRight: "10px",
                      marginBottom: "0px",
                    }}
                  >
                    Country
                  </Form.Label>
                  {/* Custom searchable country dropdown */}
                  <div style={{ position: "relative", minWidth: "180px" }}>
                    <div
                      onClick={() => setCountryDropdownOpen((prev) => !prev)}
                      style={{
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        cursor: "pointer",
                        background: "#fff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        userSelect: "none",
                        minHeight: "38px",
                      }}
                    >
                      <span style={{ color: formik.values.country ? "#000" : "#6c757d" }}>
                        {formik.values.country
                          ? (countries.find((c) => c.country_code === formik.values.country)?.country_name || formik.values.country)
                          : "All Countries"}
                      </span>
                      <i className={`fas fa-chevron-${countryDropdownOpen ? "up" : "down"}`} style={{ fontSize: "12px", marginLeft: "8px", color: "#6c757d" }} />
                    </div>
                    {countryDropdownOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 9999,
                          background: "#fff",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          minWidth: "220px",
                        }}
                      >
                        <div style={{ padding: "6px" }}>
                          <Form.Control
                            autoFocus
                            placeholder="Search country..."
                            value={countrySearch}
                            onChange={(e) => setCountrySearch(e.target.value)}
                            style={{ fontSize: "13px" }}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                          <div
                            style={{ padding: "8px 12px", cursor: "pointer", color: formik.values.country === "" ? "#0d6efd" : "#000" }}
                            onMouseDown={() => {
                              formik.setFieldValue("country", "");
                              setCountryDropdownOpen(false);
                              setCountrySearch("");
                            }}
                          >
                            All Countries
                          </div>
                          {countries.map((c) => (
                            <div
                              key={c.id}
                              style={{
                                padding: "8px 12px",
                                cursor: "pointer",
                                background: formik.values.country === c.country_code ? "#e8f0fe" : "transparent",
                                color: formik.values.country === c.country_code ? "#0d6efd" : "#000",
                              }}
                              onMouseDown={() => {
                                formik.setFieldValue("country", c.country_code);
                                setCountryDropdownOpen(false);
                                setCountrySearch("");
                              }}
                            >
                              {c.country_name} <span style={{ color: "#aaa", fontSize: "12px" }}>({c.country_code})</span>
                            </div>
                          ))}
                          {countries.length === 0 && (
                            <div style={{ padding: "8px 12px", color: "#6c757d" }}>No countries found</div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <Form.Label
                    style={{
                      textAlign: "start",
                      color: "#000",
                      fontWeight: "500",
                      marginRight: "10px",
                      marginBottom: "0px",
                    }}
                  >
                    Sound
                  </Form.Label>
                  <Form.Select
                    name="sound"
                    value={formik.values.sound}
                    onChange={formik.handleChange}
                    style={{ minWidth: "120px" }}
                  >
                    <option value="default">Default</option>
                    <option value="whitsel">Whistle</option>
                  </Form.Select>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <Form.Label
                  style={{
                    textAlign: "start",
                    color: "#000",
                    fontWeight: "500",
                    marginRight: "10px",
                    marginBottom: "0px",

                  }}
                >
                  Is Aod
                </Form.Label>

                {newData != "" && (
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    defaultChecked={formik.values.isfromfb}
                    onChange={handleAODChange}
                  />
                )}

                {newData == "" && (
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    defaultChecked={formik.values.isfromfb}
                    onChange={handleAODChange}
                  />
                )}
              </div>
              {/* OnDeviceToken Toggle */}
              <div className="d-flex align-items-center" style={{ marginTop: "15px" }}>
                <Form.Label
                  style={{
                    textAlign: "start",
                    color: "#000",
                    fontWeight: "500",
                    marginRight: "10px",
                    marginBottom: "0px",
                  }}
                >
                  On Device Token
                </Form.Label>
                <Form.Check
                  type="switch"
                  id="on-device-token-switch"
                  label=""
                  checked={formik.values.onDeviceToken || false}
                  onChange={(e) => {
                    formik.setFieldValue("onDeviceToken", e.target.checked);
                    if (!e.target.checked) {
                      formik.setFieldValue("devicetoken", "");
                    }
                  }}
                />
              </div>
              {formik.values.onDeviceToken && (
                <div className="mt-2">
                  <Form.Group controlId="deviceToken">
                    <Form.Control
                      type="text"
                      placeholder="Enter device token"
                      value={formik.values.devicetoken || ""}
                      onChange={(e) => formik.setFieldValue("devicetoken", e.target.value)}
                    />
                  </Form.Group>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "end" }}>
                <button
                  style={{ marginTop: "15px", marginRight: "15px" }}
                  onClick={() => navigate(-1)}
                  type="button"
                  className="btn btn-danger"
                >
                  CANCEL
                </button>
                <Button style={{ marginTop: "15px" }} type="submit">
                  {loader ? (
                    <CircularProgress
                      size={20}
                      style={{
                        textAlign: "center",
                        marginTop: "4px",
                        color: "#fff",
                      }}
                    />
                  ) : (
                    "SEND NOTIFICATION"
                  )}
                </Button>
              </div>
            </Card.Footer>
          </form>
        </Card>
      </Row>
    </>
  );
};
